import _ from 'lodash'

App.DataTable = class {
  constructor({ table, dataSourceUrl, columns, noData, pageLength, searchFilterHtml, initialOrder }) {
    this.searchFilterHtml = searchFilterHtml || {};
    this.table         = $(table);
    this.columns       = columns;
    this.dataSourceUrl = dataSourceUrl;
    this.noData        = noData;
    this.pageLength    = pageLength || 25;
    this.initialOrder  = initialOrder || [[1, 'asc']];
  }

  render() {
    this.renderTable();
    this.renderSearch(this);

    // Don't propagate clicks on links in columns, so row-click event doesn't fire
    this.table.find('tbody').on('click', 'a:not([data-behavior~="propagate-click-event"])', function(e) {
      e.stopPropagation();
    });
  }

  /**
   * Initialize the datatable to query the server for data with the columns in order
   */
  renderTable() {
    if ($.fn.dataTable.isDataTable(this.table)) { return; } // we want to ensure we initalize it just the once

    /* TODO Responsive option: This doesn't seem to be working (doesn't adjust as window resizes),
    and I'm not sure which fields should be hidden. Leaving for reference. */
    // responsive: { details: { display: $.fn.dataTable.Responsive.display.childRowImmediate } },
    this.table.DataTable({
      serverSide: true,
      ajax: { url: this.dataSourceUrl, type: "POST" },
      dom: 't<"clearfix"plr>',
      pageLength: this.pageLength,
      columns: this.columns,
      language: {
        emptyTable: this.noData,
        lengthMenu: "Display: _MENU_"
      },
      order: this.initialOrder
    });
  }

  formatDateSearchInput = (el) => {  
    $(el).keyup(function(e){
      let value = $(this).val();
      if(e.key === "Backspace") {
        value = value.replace(/\/$/, "");  
      }
  
      if (value.length < 3) {
        value = value.replace(/\D/g, "")
        $(this).val((value));
      }
      else if (value.length >= 3 && value.length < 6) {
        value = value.replace(/\D/g, "")
        value = [value.slice(0,2), '/', value.slice(2)].join('');
        $(this).val((value));
      }
      else if (value.length >= 6) {
        value = value.replace(/\D/g, "")
        value = [value.slice(0,2), '/', value.slice(2)].join('');
        value = [value.slice(0,5), '/', value.slice(5)].join('');
        $(this).val((value));
      }    
      $(this).val(value.substr(0,10));
    });
  }

  /**
  * Initialize the per-column search boxes
  */
  renderSearch = (dt) => {
     // Get visible column indices only
    const visibleColumns = dt.table.DataTable().columns(':visible').indexes().toArray();
  
    this.table.find('tr.search th.select-filter').each(function() {
      // Get the column title
      var title = $(this).closest('table')
                    .find('thead tr.header th')
                    .eq( $(this).index() )
                    .text();
      // Set the placeholder to 'Search [column title]'
      var searchPlaceholder = 'Search ' + title;
      $(this).html( dt.searchFilterHtml[this.id] || `<input type="text" class="form-control input-sm filter-text" placeholder="${searchPlaceholder}" name="${this.id}-input" />` );
    });

    // Force search input for dates into database format
    this.table.find('tr.search th.select-filter [placeholder="mm/dd/yyyy"]').each((_index, date_search) => {
      this.formatDateSearchInput(date_search);
    });

    /**
    * Action: Search
    * Set up search callbacks for each column on the user list.
    * Use debounce to wait 200 ms before firing the event;
    * this prevents firing an ajax request after each keyup.
    */
   this.table.find('tr.search th.select-filter input, tr.search th.select-filter select').each(function(index) {
    const columnIndex = $(this).closest('th').index();
    const actualColumnIndex = visibleColumns[columnIndex];

      $(this).on('keyup change', _.debounce(function () {
            console.log(`Searching column ${index} (actual column ${actualColumnIndex}) with value: "${this.value}"`);
        dt.table.DataTable().column(actualColumnIndex).search(this.value).draw();
      }, 300));
    });
    // this.table.DataTable().columns().every(function () {
    //   var that = this; 
      
    //   var debounce_keyup = _.debounce(function () {
    //     if (that.search() !== this.value) {
    //       that.search( this.value ).draw();
    //     }
    //   }, 200);

    //   $(dt.table.find('input, thead select')).on('keyup change', debounce_keyup);
    // });
  }


  reload(resetPaging = true) {
    let dataTable = this.table.DataTable()
    dataTable.ajax.reload(null, resetPaging)
  }
}
